import VendorContainer from "./VendorContainer";

import  VendorStore  from "./VendorStore";


export default VendorStore(VendorContainer);